import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=2e29fcc8&scoped=true"
import script from "./BindPhone.vue?vue&type=script&lang=js"
export * from "./BindPhone.vue?vue&type=script&lang=js"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=2e29fcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e29fcc8",
  null
  
)

export default component.exports